import { Badge, type BadgeProps } from '@mui/material';
import styled from '@emotion/styled';

type InnerUnreadCoachCommentsBadgeProps = BadgeProps & {
  unreadCoachCommentsCount: number;
  collapsed?: boolean;
};

const StyledBadge = styled(Badge)<BadgeProps>(({ theme, badgeContent }) => ({
  '.MuiBadge-badge': {
    transition: theme.transitions.create('all'),
    transform: 'translate(40%, -30%)',
    opacity: badgeContent === 0 ? 0 : 1,
  },
}));

const InnerUnreadCoachCommentsBadge = ({
  unreadCoachCommentsCount,
  collapsed,
  ...props
}: InnerUnreadCoachCommentsBadgeProps) => (
  <StyledBadge
    badgeContent={unreadCoachCommentsCount}
    variant={collapsed ? 'dot' : 'standard'}
    color="primary"
    {...props}
  />
);

export default InnerUnreadCoachCommentsBadge;
